import API from "api/axiosInstance";
import { changeListCabang, setIsLoading, setStatus } from "./index";

export const fetchCabang = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get(`/web-cabang`);
    dispatch(setIsLoading(false));
    dispatch(changeListCabang(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
